import {
    fetchMinimumStock,
    fetchMultipleArticles,
    fetchMultipleProducts,
    fetchProduct,
    fetchProductStock,
    fetchProducts,
    fetchProductsXlsx,
    importProductsXlsx,
} from '../queries/products.queries';

import { skipToken, useMutation, useQuery } from '@tanstack/react-query';

export const useProducts = () => {
    return useQuery({
        queryKey: ['products'],
        queryFn: fetchProducts,
    });
};

export const useProduct = (id: number) => {
    return useQuery({
        queryKey: ['product', id],
        queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchProduct(id),
    });
};

export const useMultipleProducts = (ids: number[]) => {
    return useQuery({
        queryKey: ['multipleProducts', ids],
        queryFn: () => {
            if (ids.length === 0) return [];
            return fetchMultipleProducts(ids);
        },
    });
};

export const useMinimumStock = (id: number) => {
    return useQuery({
        queryKey: ['minimumStock', id],
        queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchMinimumStock(id),
    });
};

export const useMultipleArticles = (ids: string[] | null | undefined) => {
    return useQuery({
        queryKey: ['multipleArticles', ids],
        queryFn: () => {
            if (!ids) return [];
            if (ids.length === 0) return [];
            return fetchMultipleArticles(ids);
        },
    });
};

export const useProductStock = (reference: string) => {
    return useQuery({
        queryKey: ['productStock', reference],
        queryFn: () => {
            if (!reference) return null;
            return fetchProductStock(reference);
        },
    });
};

export const useExportProductsXlsx = () => {
    return useMutation({
        mutationFn: fetchProductsXlsx,
    });
};

export const useImportProductsXlsx = () => {
    return useMutation({
        mutationFn: importProductsXlsx,
    });
};
